import { render } from "./forget.vue?vue&type=template&id=1574aedf&scoped=true"
import script from "./forget.vue?vue&type=script&lang=js"
export * from "./forget.vue?vue&type=script&lang=js"

import "./forget.vue?vue&type=style&index=0&id=1574aedf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1574aedf"

export default script